import { Helpers } from '../../helpers';
import { ICase } from '../../interfaces/icase';
import { ScenarioCase } from '../scenario-case';
import { TypeCurve } from '../type-curve';
import { TypeCurveParameter } from '../type-curve-parameter';
import { TypeCurveRisking } from '../type-curve-risking';
import { TypeCurveScaling } from '../type-curve-scaling';

export class CaseBase {
  CaseId: number;
  Name: string | null;
  CreatedDate: Date | null;
  UpdatedDate: Date | null;
  CreatedById: number | null;
  UpdatedById: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScenarioCases_Case?: Array<ScenarioCase> | null;
  TypeCurveParameters_Case?: Array<TypeCurveParameter> | null;
  TypeCurveRisking_Case?: Array<TypeCurveRisking> | null;
  TypeCurves_Case?: Array<TypeCurve> | null;
  TypeCurveScaling_Case?: Array<TypeCurveScaling> | null;

  constructor(item?: ICase) {
    if (item) {

      this.CaseId = item.CaseId;
      this.Name = item.Name;
      this.CreatedDate = item.CreatedDate ? new Date(item.CreatedDate) : null;
      this.UpdatedDate = item.UpdatedDate ? new Date(item.UpdatedDate) : null;
      this.CreatedById = item.CreatedById;
      this.UpdatedById = item.UpdatedById;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScenarioCases_Case = Helpers.createClassArray(ScenarioCase, item.ScenarioCases_Case);
      this.TypeCurveParameters_Case = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_Case);
      this.TypeCurveRisking_Case = Helpers.createClassArray(TypeCurveRisking, item.TypeCurveRisking_Case);
      this.TypeCurves_Case = Helpers.createClassArray(TypeCurve, item.TypeCurves_Case);
      this.TypeCurveScaling_Case = Helpers.createClassArray(TypeCurveScaling, item.TypeCurveScaling_Case);
    }
  }
}